import React, { useState, ChangeEvent, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Upload, message, Typography, Table } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import {
  ClientDealingScenarioDataType,
  ClientDealingScenarioType,
  fetchClientDealingScenarioData,
  selectors,
  uploadClientDealingScenario,
} from 'state';
import { CSVLink } from 'react-csv';
import { downloadedScenarioData } from '../../../state/app/selectors';
import { formatters, useModal } from 'services';
import ActionModal from '../Sessions/ActionModal';
import CreateClientDealingScenarioModal from './CreatClientDealingScenario';

const { Text } = Typography;

const ClientDealing: React.FC = () => {
  const dispatch = useDispatch();
  const scenarios = Object.values(
    useSelector(selectors.ClientDealingScenarios)
  );
  const waiting_data = useSelector(selectors.waiting);
  const [createScenarioModal, showModal] = useModal(
    CreateClientDealingScenarioModal
  );

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Start Date',
      dataIndex: 'first_date_in_session',
      key: 'first_date_in_session',
    },
    {
      title: 'End Date',
      dataIndex: 'session_end_date',
      key: 'session_end_date',
    },
    {
      title: 'Freq.',
      dataIndex: 'period_frequency',
      key: 'period_frequency',
    },
    {
      title: 'Starting LDR',
      dataIndex: 'starting_ldr',
      key: 'starting_ldr',
    },
    {
      title: 'Alpha',
      dataIndex: 'alpha',
      key: 'alpha',
    },
    {
      title: 'Gamma',
      dataIndex: 'gamma',
      key: 'gamma',
    },
    {
      title: 'Aum',
      dataIndex: 'aum',
      key: 'aum',
      render: (val: number, record: any) => {
        return formatters.commasNoDigits(val);
      },
    },
    {
      title: 'Pool Factor',
      dataIndex: 'total_pool_factor',
      key: 'total_pool_factor',
    },
    {
      title: 'Players',
      dataIndex: 'no_of_players',
      key: 'no_of_players',
    },
    {
      title: 'Action',
      key: 'action',
      dataIndex: 'id',
      render: (_: any, record: ClientDealingScenarioType) => {
        return (
          <div>
            {waiting_data ? (
              <Button type={'link'}>Loading</Button>
            ) : (
              <Button
                type={'link'}
                onClick={() =>
                  dispatch(
                    fetchClientDealingScenarioData({ scenario_id: record.id })
                  )
                }
              >
                {/*<CSVLink filename={'PM_prod_assets'} data={''}>*/}
                Download CSV
                {/*</CSVLink>*/}
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div style={{ padding: 24, maxWidth: 480 }}>
      {/*TODO: Create will open up a modal to select name, start_date, end_date and frequency*/}
      <Button
        type={'primary'}
        style={{ marginBottom: 15 }}
        onClick={() => showModal({})}
      >
        Create
      </Button>

      <Table
        style={{ width: 1400 }}
        dataSource={scenarios}
        columns={columns}
        bordered
      />
      {createScenarioModal}
    </div>
  );
};

export default ClientDealing;
